import { Wallet, Percent, Clock, ArrowDownToLine, UserCircle, Eye, ShieldCheck } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

const ICONS = [Wallet, Percent, Clock, ArrowDownToLine, UserCircle, Eye];

export const Conditions = () => {
  const { t } = useT();
  return (
    <section id="konditionen" data-testid="conditions-section" className="relative py-24 sm:py-32 bg-white border-y border-[var(--al-line)]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <span className="al-tag">{t.cond.tag}</span>
          <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-tight">
            {t.cond.h2a}<span className="al-grad-text">{t.cond.h2b}</span>
          </h2>
          <p className="mt-6 text-slate-600 leading-relaxed">{t.cond.sub}</p>

          <div className="mt-9 al-card p-6 al-grad-soft-bg">
            <div className="flex items-center gap-2 text-slate-700 font-display font-semibold">
              <ShieldCheck className="h-5 w-5 text-[var(--al-purple)]" /> {t.cond.benefitsTitle}
            </div>
            <ul className="mt-4 space-y-2.5">
              {t.cond.benefits.map((y, i) => (
                <li key={i} data-testid={`condition-benefit-${i}`} className="flex items-start gap-2.5 text-[15px] text-slate-700">
                  <span className="mt-1.5 h-1.5 w-1.5 rounded-full al-grad-bg flex-shrink-0" />
                  <span>{y}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
          {t.cond.items.map((c, i) => {
            const Icon = ICONS[i] || Wallet;
            return (
              <div key={c.label} data-testid={`condition-card-${i}`} className="al-card p-6">
                <div className="h-11 w-11 rounded-xl flex items-center justify-center al-grad-soft-bg">
                  <Icon className="h-5 w-5 text-[var(--al-purple)]" />
                </div>
                <div className="mt-5 text-xs uppercase tracking-widest font-semibold text-slate-500">{c.label}</div>
                <div className="mt-1.5 font-display font-semibold text-xl text-slate-900">{c.value}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
